<template>
  <div class="container-fluid page">
    <div class="row mt-4 flex-grow-1">
      <div class="col-12">
        <card class="h-100">

          <div class="row">
            <div class="col-12">
              <h2>Connected Retailers</h2>
            </div>
          </div>

          <div class="row content">
            <div class="col-3 sidebar">
                <div class="charities">
                  <div class="charity" v-for="rl in retailerLeads" :key="'rl-' + rl.id">
                    <div class="charity-lead" :class="selectedRetailerLead && selectedRetailerLead.id === rl.id ? 'active' : null" @click="selectRetailerLead(rl)">
                      <div class="charity-lead-info">
                        <location-icon :logo="rl.logoUrl"></location-icon>
                        <p class="description">
                          {{ rl.name }}
                        </p>
                      </div>
                    </div>
                    <div class="charity-branches" v-if="selectedRetailerLead && selectedRetailerLead.id === rl.id">
                      <div class="charity-branch" :class="selectedRetailerBranch && selectedRetailerBranch.id === rb.id ? 'active' : null" v-for="rb in rl.retailers" :key="'rb-' + rb.id" @click="selectRetailerBranch(rb)">
                        <p class="description">
                          <strong>{{ rb.name }}</strong><br>
                          {{ rb.address_line_1 }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <div class="col-9" v-if="selectedRetailerBranch">
              <resources-card :resources="[...resources.allergenInformation, ...resources.foodInformation]"></resources-card>
            </div>
          </div>
        
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  // Imports
  import ResourcesCard from '@/components/Cards/ResourcesCard';
  import RetailerRotaCard from '@/components/Cards/RetailerRotaCard';
  import RetailerLeadsService from '../../../services/RetailerLeadsService';
  import RetailersService from '../../../services/RetailersService';
  import CharitiesService from '../../../services/CharitiesService';
  import UploadsService from '../../../services/UploadsService';
  import UserStore from '../../../services/UserStore';
  import LocationIcon from '../../../components/LocationIcon';

  export default {
    name: 'retailer-lead-connected-charities',

    components: {
      LocationIcon,
      ResourcesCard
    },

    data() {
      return {
        retailerLeads: [],
        selectedRetailerLead: null,
        selectedRetailerBranch: null,
        resources: {
          allergenInformation: [],
          foodInformation: []
        }
      };
    },
    
    created: async function(){
      this.fetchRetailerLeads();
    },

    methods:{
      async fetchRetailerLeads() {
        try {
          const retailerLeadsRes = await CharitiesService.getOwnConnectedRetailers();
          this.retailerLeads = retailerLeadsRes.data;
        }
        catch(err) {
          console.log('Error fetching Retailer Leads', err);
          alert('Oops! Somthing went wrong, the page may not have loaded correctly. Please try again.');
        }
      },

      selectRetailerLead(rl) {
        this.selectedRetailerLead = rl;
      },

      async selectRetailerBranch(rb) {
        this.selectedRetailerBranch = rb;

        try {
          // Fetch related uploads
          this.fetchResources();
        }
        catch(err) {
          console.log('Error getting charity', err);
          alert('Oops! Something went wrong, the page might not have loaded correctly.');
        }
      },

      async fetchResources() {
        let allergenInformation = await UploadsService.getAll({
          group: 'RetailerLead',
          groupEntityId: this.selectedRetailerLead.id,
          fileCategory: 'allergen-information'
        });

        this.resources.allergenInformation = allergenInformation.data.map((u) => {
          return {
            uploadId: u.id,
            description: 'Allergen Information'
          }
        });

        let foodInformation = await UploadsService.getAll({
          group: 'RetailerLead',
          groupEntityId: this.selectedRetailerLead.id,
          fileCategory: 'food-information'
        });

        this.resources.foodInformation = foodInformation.data.map((u) => {
          return {
            uploadId: u.id,
            description: 'Food Information'
          }
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
    .page {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 8rem);
  }

  .content {
    position: absolute;
    top: 6.25rem;
    left: 15px;
    width: 100%;
    height: calc(100% - 6.25rem);
    border-top: 1px solid #E5EAF3;
  
    .sidebar {
      border-right: 1px solid #E5EAF3;
      padding: 0;
    }
  }


  .charities {
    // margin-top: 6.25rem;

    .charity-lead {
      padding: 1.25rem;
      transition: background-color 250ms ease;
      border-bottom: 1px solid #E5EAF3;
      cursor: pointer;

      &.active {
        background-color: #EFF0F6;
        border-left: 0.375rem solid #F95940;
        padding-left: (1.25rem - 0.375rem);
      }

      .charity-lead-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-items: center;
      
        .logo {
          width: 2.8125rem;
          border-radius: 50%;
          margin-right: 0.75rem;
        }

        .description {
          margin: 0;
          padding: 0;
          font-size: 0.9573rem;
          line-height: 1.125rem;
        }
      }
    }

    .charity-branches {
      .charity-branch {
        padding: 0.75rem;
        cursor: pointer;

        &.active {
          background-color: #F9F9F9;
          border-right: 0.375rem solid #F95940;
          padding-right: (0.75rem - 0.375rem);
        }
        
        .description {
          margin: 0;
          padding: 0;
          font-size: 0.9573rem;
          line-height: 1.125rem;
          text-align: right;
        }

      }
    }
  }
</style>
